<template lang="pug">
b-modal(id="modal-user_info_add" hide-header-close no-close-on-esc no-close-on-backdrop title="アカウント情報を入力してください。")
  div.form-group
    label(for='company_name') 会社名
    input.form-control(type='text',
      placeholder='株式会社⚪︎⚪︎⚪︎（個人の場合は「個人」と記入）',
      name='company_name',
      v-model="company_name"
    )
  div.form-group
    label(for='tel')  電話番号(ハイフン無し)
      .badge.badge-primary *必須
    input.form-control(type='text',
      placeholder="08012345678",
      name='tel',
      v-model="tel"
    )
    small.text-danger(v-if="tel != '' && !validateTel()") ※数字のみで指定してください。

  //- div.form-group
  //-   label(for='label')  ドメインの名前
  //-     .badge.badge-primary *必須
  //-   input.form-control(type='text',
  //-     placeholder="SiteLead",
  //-     name='label',
  //-     v-model="label"
  //-   )
  //-   small.text-danger(v-if="label != ''")

  div.form-group
    label(for='tel') WebサイトのURL
      .badge.badge-primary *必須
    input.form-control(type='text',
      placeholder="https://sample.com",
      name='host',
      v-model="host"
    )
    div
      small.text-danger(v-if="host != '' && !validateHost()") ※正しいURLを指定してください。

  template(v-slot:modal-footer)
    template.text-center(v-if="validateTel() && validateHost()")
      b-button(variant="success", @click="submit($event, 'heatmaps')" ) ヒートマップを利用する
    template.text-center(v-else)
      b-button(variant="success" disabled ) ヒートマップを利用する
    
    template.text-center(v-if="validateTel() && validateHost()")
      b-button(variant="success", @click="submit($event, 'popups')" ) ポップアップを利用する
    template.text-center(v-else)
      b-button(variant="success" disabled ) ポップアップを利用する
    
    template.text-center(v-if="validateTel() && validateHost()")
      b-button(variant="success", @click="submit($event, 'popups')" ) オーバーレイを利用する
    template.text-center(v-else)
      b-button(variant="success" disabled ) オーバーレイを利用する
</template>

<script>
  import Vue from 'vue'

  export default {
    props: {
      policy_accepted_at: String
    },
    data() {
      return {
        company_name: '',
        tel: '',
        host: '',
        label: '',
      }
    },
    methods: {
      validateHost() {
        const urlRegex = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]+)*(\/[\w-]+\.[\w-]+)*(\/?)(\?.*)?$/;
        return urlRegex.test(this.host) || this.host.startsWith('http://') || this.host.startsWith('https://');
      },
      validateTel() {
        const telRegex = /^\d+$/;
        return telRegex.test(this.tel);
      },
      async submit(e, path){
        e.preventDefault();
        // ディレクトリは削除して登録
        const urlObject = new URL(this.host);
        const host = `${urlObject.protocol}//${urlObject.hostname}`;
        await this.$store.dispatch("user/saveUserInfo", {
          tel: this.tel,
          host: host,
          company_name: this.company_name,
          label:this.label
        })
        window.location.href = '/users/'+path; 
        this.$bvModal.hide('modal-user_info_add')
      },
    },
    components: {
    },
    async mounted(){
      await Vue.nextTick()
      this.$bvModal.show('modal-user_info_add')
    },
  }
</script>

<style lang="scss" scoped>
.modal-footer {
  justify-content: center;
}
.btn-auth-login {
  background-color: #ffffff;
  border-radius: 20px;
}
.icon-google {
  background-color: #ffffff;
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  width: 30px;
  height: 30px;
}
</style>
  
  